import {useEffect, useState} from "react";

/**
 *
 * @param initialValue: {any}
 * @param validatorFn {function}
 * @returns {[any, function, boolean, function, boolean]}
 */
function useFormField(initialValue, validatorFn = (str) => str.length > 0) {
    const [formFieldValue, setFormFieldValue] = useState(initialValue)
    const [focusReceivedOnce, setFocusReceivedOnce] = useState(false)
    const [shouldShowError, setShouldShowError] = useState(false)
    const [isFormFieldValid, setIsFormFieldValid] = useState(false)

    useEffect(() => {
        setIsFormFieldValid(validatorFn(formFieldValue || ''))
    }, [formFieldValue, validatorFn])

    const handleFocus = () => {
        setFocusReceivedOnce(true)
    }

    useEffect(() => {
        setShouldShowError(focusReceivedOnce && !isFormFieldValid)
    }, [isFormFieldValid, focusReceivedOnce])

    return [formFieldValue, setFormFieldValue, isFormFieldValid, handleFocus, shouldShowError]
}

export default useFormField